export default function (cfpLoadingBarProvider) {
    cfpLoadingBarProvider.includeSpinner = false;
}



// WEBPACK FOOTER //
// ./Client/app/common/config/generic.js